<template>
    <div class="window-wrapper window-save-email">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">На вашу почту выслано письмо для подтверждения email. Старая почта действует до подтверждения нового почтового адреса.</div>
                    <div class="button-block">
                        <button class="button button-dark button-close-window dev_close_window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SaveEmailWindow",
        mounted() {
            $('.dev_close_window').on('click', function(e){
                $('.window-save-email').removeClass('window-open');
                $('body').removeClass('blocked');
            });
        }
    }
</script>

<style scoped>
</style>